module.exports = __webpack_public_path__ + "img/OklahomaLogo.205f3915.jpg";